import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { VideoContent } from '../../../types/content';
import { setVideoProgress } from '../../../store/player/slice';
import { CustomPlayer } from '..';

interface VideoPlayerProps {
  video: VideoContent;
  className?: string;
  onError?: (error: Error) => void;
  autoplay?: boolean;
  onViewerCountUpdate?: (count: number) => void;
  onAddToCalendar?: () => void;
  onSetReminder?: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  video,
  className,
  onError,
  autoplay = false,
  onViewerCountUpdate,
  onAddToCalendar,
  onSetReminder
}) => {
  const dispatch = useDispatch();

  const handleProgress = useCallback((progress: number) => {
    dispatch(setVideoProgress(progress));
  }, [dispatch]);

  return (
    <CustomPlayer
      video={video}
      className={className}
      onError={onError}
      autoplay={autoplay}
      onViewerCountUpdate={onViewerCountUpdate}
      onAddToCalendar={onAddToCalendar}
      onSetReminder={onSetReminder}
      onProgress={handleProgress}
    />
  );
};

export default VideoPlayer;